module.exports = __webpack_public_path__ + "static/img/RK664-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RK664-G_1.png
// module id = 6e/8
// module chunks = 0